export const LABELS = {
    HOME: "Home",
    PRODUCTS: 'Products',
    PRODUCT_DETAILS: 'Product Details',
    SERVICES: 'Services',
    SERVICE_DETAILS: 'Service Details',
    INSTALLED_PROJECTS: 'Installed Projects',
    ABOUT_US: 'About us',
};